export default "__VITE_ASSET__CpvsnT5q__"